///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const SendIcon = ({
  className,
  height,
  fill,
  title = messages.send.defaultMessage,
  width,
  ...rest
}) => (
  <svg
    aria-labelledby="send-icon"
    height={height}
    viewBox="0 0 16 16"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...rest}
  >
    <title id="send-icon">{title}</title>
    <path
      fill={fill}
      d="M2.67333333,4.02 L7.68,6.16666667 L2.66666667,5.5 L2.67333333,4.02 M7.67333333,9.83333333 L2.66666667,11.98 L2.66666667,10.5 L7.67333333,9.83333333 M1.34,2 L1.33333333,6.66666667 L11.3333333,8 L1.33333333,9.33333333 L1.34,14 L15.3333333,8 L1.34,2 Z"
    />
  </svg>
);

export default SendIcon;
